import { Box } from "@mui/material";
import SectionHeader from "../../../../components/section-header/SectionHeader";
import SectionHeaderActions from "../../../../components/section-header/SectionHeaderActions";
import SectionHeaderSearch from "../../../../components/section-header/SectionHeaderSearch";
import CompanyUpdatesDataGrid from "./CompanyUpdatesDataGrid";
import { useRef, useState } from "react";




export default function CompanyUpdates() {
  const gridRef = useRef(null);
  const [searchText, setSearchText] = useState("");
  return (
    <>
    <Box display="flex" flexDirection="column" gap={1.3} mt={2}>
      <SectionHeader
        left={
          <SectionHeaderSearch
            searchValue={searchText}
            onSearchChange={setSearchText}
            onFilterClick={() => gridRef.current?.openFiltersPanel()}
            onColumnClick={() => gridRef.current?.openColumnsPanel()}
          />
        }
        right={<SectionHeaderActions onExport={() => gridRef.current?.exportToExcel()} />}
      />

      {/* Table goes here */}
      <CompanyUpdatesDataGrid
       ref={gridRef}
       searchText={searchText}
       /> 
      </Box>
    </>
  );
}
